import styled from "styled-components";
import { STYLED_CONSTANTS } from "./constant";

export const ImageContainer = styled.div<{ isError?: boolean }>(({ isError }) => ({
    width: "100%",
    display: "flex",
    justifyContent: isError ? "flex-start" : "center",
}));

export const HeadingTitleContainer = styled.div<{ isError?: boolean }>(({ theme, isError }) => ({
    marginTop: isError ? theme.spacing.small : theme.spacing.xSmall,
}));

export const DescriptionContainer = styled.div(({ theme }) => ({
    marginTop: theme.spacing.xSmall,
}));

export const ContentContainer = styled.div(({ theme }) => ({
    display: "flex",
    flexDirection: "column" as const,
    alignItems: "flex-start" as const,
    paddingTop: theme.spacing.medium,
    paddingLeft: theme.spacing.medium,
    paddingRight: theme.spacing.medium,
    paddingBottom: STYLED_CONSTANTS.MARGIN_BOTTOM,
    background: theme.colors[theme.colorMode].canvas_Primary,
}));

export const ButtonContainer = styled.div(({ theme }) => ({
    display: "flex",
    gap: theme.spacing.small,
    width: "100%",
    marginTop: theme.spacing.xLarge,
    paddingBottom: "var(--sab, 0px)",
}));

export const FlexCta = styled.div({
    flex: "1 1 0",
});
